import mockReport from '@mocks/report_1.json';

import { APP_CONFIG } from '@common/configs';

import { api } from './apiClient';
import type { ILoginPayload, IReportData, ISignedReport } from './types';

export const fetchSignedReport = async (payload: ILoginPayload): Promise<ISignedReport> => {
  const result = await api<ISignedReport, ILoginPayload>(APP_CONFIG.API_URL_REPORTING, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: payload,
  });

  return result;
};

export const fetchReportData = async (url: string): Promise<IReportData> => {
  const { report } = await api<{ report: IReportData }>(url);

  // TODO: remove mock data merging after BE improvements
  // Updated sections: Creatives and Contact are added for testing purposes
  const replacedSections = ['creatives', 'cost', 'contact'];
  const mockMap = new Map(
    mockReport.sections.map((section) => {
      return [section.id, section];
    })
  );
  const reportIds = new Set(
    report.sections.map((section) => {
      return section.id;
    })
  );

  const mergedSections = [
    ...report.sections.map((section) => {
      // return replacedSections.includes(section.id) && mockMap.has(section.id) ? mockMap.get(section.id)! : section;
      const mockSection = mockMap.get(section.id);
      if (replacedSections.includes(section.id) && mockSection) {
        return mockSection;
      }
      return section;
    }),
    ...mockReport.sections.filter((section) => {
      return !reportIds.has(section.id);
    }),
  ] as IReportData['sections'];

  return {
    ...report,
    sections: mergedSections,
  };
};
